<template>
  <product-category-path
    class="product-category-hierarchy"
    :categories="categories"
  />
</template>

<script>
import ProductCategoryPath from '@/components/ProductCategoryPath';

export default {
  name: 'product-category-hierarchy',
  components: {
    ProductCategoryPath,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
    hideLast: Boolean,
  },
  computed: {
    categories() {
      let items = [];
      if (this.category.ancestors) {
        items = items.concat(this.category.ancestors);
      }
      if (!this.hideLast) {
        items.push(this.category);
      }
      return items;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductCategoryHierarchy.vue?22841652